import React, { createContext, useState } from 'react';

// Create Context
export const SharedFormContext = createContext();

// Provider Component
export const SharedFormProvider = ({ children }) => {
    const [sharedData, setSharedData] = useState({});

    // Update data function
    const updateSharedValue = (key, value) => {
        setSharedData((prev) => ({ ...prev, [key]: value }));
    };

    // Helper to get value safely
    const getSharedValue = (key, defaultValue = '') => {
        return sharedData[key] !== undefined ? sharedData[key] : defaultValue;
    };

    return (
        <SharedFormContext.Provider value={{ sharedData, updateSharedValue, getSharedValue }}>
            {children}
        </SharedFormContext.Provider>
    );
};
